import { withTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { SideBarContainer, SideBarHeader, SideBarContent, SideBarSection, SideBarHeaderContent } from '../../common/SideBarContainer'
import TagSelect from './TagSelect'
import StatusSelect from './StatusSelect'
import AdditionalInformation from './AdditionalInformation'
import ContactDetails from './ContactDetails'

// const NAME_DISPLAY_STYLE = {
//   width: '100%',
//   fontSize: '15px',
//   fontWeight: 600,
//   borderRadius: '6px',
//   fontFamily: 'Inter,sans-serif',
//   color: '#54AEBD',
// }

const InfoPanel = ({ selectionStore, dataStore }) => {
  // Boundary names come from a shared external admin/zip-code lookup table,
  // not a column on the boundary itself - there's nothing to rename yet.
  const item = selectionStore.item ? selectionStore.item : null
  // const [editing, setEditing] = useState(false)

  // const isBoundary = selectionStore.type === selectionTypes.BOUNDARY ||
  //   selectionStore.type === selectionTypes.ZIP_CODE_BOUNDARY

  // const save = async (value) => {
  //   const item = selectionStore.item
  //   if (!item || !value || value === item.name) return
  //   item.name = value
  //   await item.rename(value)
  // }

  const statusOptions = selectionStore.statusOptions

  const statusId = item && item.status ? item.status : null
  const statusValue = statusId ? statusOptions.find(option => option.id === statusId) : null

  const tagOptions = dataStore.tagOptions
  const tagIds = item && item.tag_ids ? item.tag_ids : []
  const tagValue = tagOptions.filter(tag => tagIds.includes(tag.id))

  const handleTagChange = (_, actionMeta) => {
    if (actionMeta.action === 'remove-value') {
      selectionStore.item.deleteTag(actionMeta.removedValue.id)
    }
    if (actionMeta.action === 'select-option') {
      selectionStore.addTag(actionMeta.option)
    }
    if (actionMeta.action === 'clear') {
      actionMeta.removedValues.forEach(tag => selectionStore.item.deleteTag(tag.id))
    }
  }

  const handleStatusChange = (selectedOption) => {
    selectionStore.selectStatus(selectedOption)
  }

  return (
    <SideBarContainer>
      <SideBarHeader>
        <SideBarHeaderContent title='Information' itemName={item ? item?.name : ''} />
      </SideBarHeader>
      <SideBarContent style={{ paddingLeft: 20, paddingRight: 20 }}>
        {
          !item
            ? (
              <div>
                Please select an item
              </div>
              )
            : (
              <>
                <SideBarSection title='Overview' style={{ gap: '14px !important' }}>
                  <StatusSelect options={statusOptions} value={statusValue} onChange={handleStatusChange} />
                  <TagSelect options={tagOptions} value={tagValue} onChange={handleTagChange} />
                </SideBarSection>
                <SideBarSection title='Contact details'>
                  <ContactDetails key={`${selectionStore.type}-${item.id || item.pk}`} />
                </SideBarSection>
                <AdditionalInformation />
              </>
              )

        }

      </SideBarContent>
    </SideBarContainer>
  )
}

export default withTranslation()(
  inject('uiStore', 'selectionStore', 'dataStore')(observer(InfoPanel))
)
